import { render, staticRenderFns } from "./NewDesktopServicePromotion.vue?vue&type=template&id=93fa41fa&scoped=true&"
import script from "./NewDesktopServicePromotion.vue?vue&type=script&lang=js&"
export * from "./NewDesktopServicePromotion.vue?vue&type=script&lang=js&"
import style0 from "./NewDesktopServicePromotion.vue?vue&type=style&index=0&id=93fa41fa&scoped=true&lang=css&"
import style1 from "./NewDesktopServicePromotion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa41fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93fa41fa')) {
      api.createRecord('93fa41fa', component.options)
    } else {
      api.reload('93fa41fa', component.options)
    }
    module.hot.accept("./NewDesktopServicePromotion.vue?vue&type=template&id=93fa41fa&scoped=true&", function () {
      api.rerender('93fa41fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/ServicePromotion/NewDesktopServicePromotion.vue"
export default component.exports